import React from 'react';
import DrivingEnvironment from './drivingEnvironment';
import AnimatedCar from './animatedCar';

interface AnimatedDrivingSceneProps {
  title?: string;
  subtitle?: string;
  hasError?: boolean;
}

const AnimatedDrivingScene: React.FC<AnimatedDrivingSceneProps> = ({ 
  hasError = false,
}) => {
  return (
    <div className="animated-driving-scene">
      {/* Background environment */}
      <div className="scene-background">
        <DrivingEnvironment />
      </div>
      
      {/* Animated car on road */}

      <div className="scene-car-container"> 
        <AnimatedCar hasError={hasError} />
      </div>
      
     
    </div>
  );
};

export default AnimatedDrivingScene;
